module.exports = __webpack_public_path__ + "static/media/pin_gcm_vehicle.e525d7b4.svg";